import {TipoCFEDTO} from '../TipoCFEDTO';

export class DatosInicioReferenciasDTO
{
  tiposCFEsDTOs: Array<TipoCFEDTO>;
  codigoTipoCFESeleccionado: number;
  mostrarReferenciaEspecifica: boolean;
}
